import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const ChevronRight = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsx("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M9.4 18.9863L16 11.9863L9.4 4.98627",
            stroke: "currentColor",
            strokeWidth: 2 * (24 / size),
            strokeMiterlimit: "10",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
